module.exports = __webpack_public_path__ + "img/vendor_logo10.f1215194.png";